import React from 'react';

import classnames from 'clsx';
import { Helmet } from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';

import AddonsSelection from '../AddonsSelection';
import BookingInformation from '../BookingInformation';
import StepIndicator from '../StepIndicator';

import Payment from './AddItemPayment';

/******* Names of steps in the order process **/
const BOOKING_INFORMATION = 'booking-information';
const ADDONS_SELECTION = 'add-ons-selection';
const PAYMENT = 'payment';

// componentMap is a mapping from names of steps to components to render
const componentMap = {
  [BOOKING_INFORMATION]: BookingInformation,
  [ADDONS_SELECTION]: AddonsSelection,
  [PAYMENT]: Payment,
};

// labelMap maps step names to human friendly labels
const labelMap = {
  [BOOKING_INFORMATION]: 'Booking Information',
  [ADDONS_SELECTION]: 'Add-ons Selection',
  [PAYMENT]: 'Payment',
};

// steps is an array of steps in an ordered sequence
const steps = [BOOKING_INFORMATION, ADDONS_SELECTION, PAYMENT];

const stepNames = [labelMap[BOOKING_INFORMATION], labelMap[ADDONS_SELECTION], labelMap[PAYMENT]];

function AddItemPage(props) {
  const { step } = useParams();
  const history = useHistory();

  function getCurrentStepIdx() {
    return steps.indexOf(step);
  }

  function getCurrentStepComponent() {
    const Component = componentMap[step];
    if (Component) {
      return Component;
    }

    const firstStepName = steps[0];
    return componentMap[firstStepName];
  }

  function _transitionStep(stepName) {
    const { user, orderId } = props;

    history.push(`/users/${user.id_member}/edit-orders/${orderId}` + `/add-item/${stepName}`);
  }

  function proceedStep() {
    const currentStepIdx = getCurrentStepIdx();
    const nextStep = steps[currentStepIdx + 1];
    if (!nextStep) {
      return;
    }

    _transitionStep(nextStep);
  }

  function getNextStepName() {
    const currentStepIdx = getCurrentStepIdx();
    const nextStep = steps[currentStepIdx + 1];

    return labelMap[nextStep];
  }

  function handleCancelOrderProcess() {
    const { onEmptyCart, orderId } = props;

    onEmptyCart();
    history.push(`/purchases/${orderId}`);
  }

  function backStep() {
    const currentStepIdx = getCurrentStepIdx();
    const prevStep = steps[currentStepIdx - 1];

    if (!prevStep) {
      return handleCancelOrderProcess();
    }

    _transitionStep(prevStep);
  }

  const { user, orderId } = props;

  const Component = getCurrentStepComponent();

  return (
    <div className="new-order-page" data-no-dark-override>
      <Helmet>
        <title>Users | {user.fullName} | Add item</title>
      </Helmet>
      <div className="new-order-header">
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h1 className="new-order-heading">Add item: {user.fullName}</h1>
              <span className="user-email">{user.email}</span>

              <a
                onClick={(e) => {
                  e.preventDefault();
                  handleCancelOrderProcess();
                }}
                href="#cancel-order-process"
                className="cancel-btn"
              >
                Cancel
              </a>

              <StepIndicator currentStepIdx={getCurrentStepIdx()} steps={steps} stepNames={stepNames} />
            </div>
          </div>
        </div>
      </div>

      <main className={classnames('new-order-body', step)}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <Component
                allowToggleReservationType
                disableChangeCurrency
                proceedStep={proceedStep}
                backStep={backStep}
                nextStepLabel={getNextStepName()}
                user={user}
                orderId={orderId}
              />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AddItemPage;
